module.exports = __webpack_public_path__ + "static/dell-xps-15@3x-b3459bea1d24fdf4574d0ec59d02e410.png";